<template>
  <form @submit.prevent="submitForm" class="" method="POST">
    <!-- These hidden fields are just for fallback -->
    <input type="hidden" name="action" :value="action">
    <input type="hidden" hidden="purchasableId" :value="itemId">
    <input type="hidden" :name="$root.$options.csrf.name" :value="$root.$options.csrf.value">
    <input v-if="compact" type="hidden" name="qty" value="1">

    <!-- Compact version -->
    <button v-if="compact" type="submit" class="border-none text-orange-darker uppercase font-sans py-3">
      <transition name="fade" mode="out-in">
        <vue-simple-spinner v-if="loading"  :size="16" :line-size="2" line-bg-color="#D1865F" line-fg-color="#FFF" />
        <span v-else>
          <svg class="plus-dims w-2 h-2 mr-2">
            <use xlink:href="#plus"></use>
          </svg>
          Add
        </span>
      </transition>
    </button>

    <!-- Full version with quantity -->
    <div v-else class="inline-flex border border-grey-lightest mb-8">
      <qty-input class="py-2 px-6 border-r border-grey-lightest" ref="qtyInput"></qty-input>

      <button type="submit" class="btn text-orange-darker border-0 py-2 px-6">
        <transition name="fade" mode="out-in">
          <vue-simple-spinner v-if="loading"  :size="16" :line-size="2" line-bg-color="#D1865F" line-fg-color="#FFF" />
          <span v-else>Add to Cart</span>
        </transition>
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import VueSimpleSpinner from 'vue-simple-spinner';
import { EventBus } from "../../lib/event-bus.js";
import QtyInput from "./QtyInput";

export default {
  props: {
    action: {
      type: String,
      default: 'commerce/cart/updateCart'
    },

    itemId: {
      required: true
    },

    compact: {
      default: false
    }
  },

  data() {
    return {
      loading: false
    }
  },

  components: {
    VueSimpleSpinner,
    QtyInput
  },

  methods: {
    submitForm(event) {
      // example of looping through form, needs polyfills
      // const formData = new FormData(event.target);
      // for (const pair of formData.entries()) {
      //   params.append(
      //     encodeURIComponent(pair[0]),
      //     encodeURIComponent(pair[1])
      //   );
      // }

      this.loading = true;

      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      params.append(this.$root.$options.csrf.name, this.$root.$options.csrf.value);
      params.append('action', this.action);
      params.append('purchasableId', this.itemId);
      params.append('qty', this.compact ? 1 : this.$refs.qtyInput.qty);

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        this.loading = false;
        EventBus.$emit('open-cart', { reload: true });
      })
      .catch((error) => {
        this.loading = false;
        console.log('Add to Cart Error:', error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/AddToCart.vue